module.exports = __webpack_public_path__ + "static/img/logo_35.fe7de2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo_35.png
// module id = Imy7
// module chunks = 1